import React, { Key } from "react"
import { Divider, Flex, Table } from "antd"
import { SUB_TABLE_BACKGROUND } from "../../../constants/table.constants"
import { ICampaignDataColumns, ITarget, ITargetColumns } from "../types/table"
import { ColumnType } from "antd/es/table"
import { TableRowSelection } from "antd/es/table/interface"
import NotDataWarning from "../../../ui/NotDataWarning"

interface SponsoredProductsViewProps {
  campaignsColumns: ColumnType<ICampaignDataColumns>[]
  data: ICampaignDataColumns[]
  rowSelection: TableRowSelection<ICampaignDataColumns>
  loading: boolean
  targetsColumns: ColumnType<ITargetColumns>[]
  targetRowSelection: TableRowSelection<ITargetColumns>
  expandedRowCampaignIds: readonly Key[]
  onExpandedRowsChange: (expandedRowKeys: readonly Key[]) => void
  lastDateWithoutData: string
}

const SponsoredProductsView: React.FC<SponsoredProductsViewProps> = ({
  campaignsColumns,
  data,
  rowSelection,
  loading,
  targetsColumns,
  targetRowSelection,
  expandedRowCampaignIds,
  onExpandedRowsChange,
  lastDateWithoutData,
}) => {
  return (
    <Flex vertical gap={10}>
      <Divider>Sponsored Products</Divider>
      {lastDateWithoutData ? (
        <NotDataWarning
          date={lastDateWithoutData}
          doMessage={
            "Most likely, there have been no new data (views, clicks, sales) since this date. If you believe that data exists, please contact the development team to fix the issue."
          }
        />
      ) : null}

      <Table
        rowKey="campaignId"
        columns={campaignsColumns}
        dataSource={data}
        rowSelection={rowSelection}
        showSorterTooltip={{ target: "sorter-icon" }}
        scroll={{ x: "max-content", y: window.innerHeight }}
        loading={loading}
        expandable={{
          expandedRowRender: (record) => (
            <Table<ITarget>
              rowKey="targetId"
              virtual
              columns={targetsColumns}
              dataSource={record.targets}
              pagination={false}
              showHeader={false}
              showSorterTooltip={{ target: "sorter-icon" }}
              scroll={{ x: "max-content", y: 500 }}
              onRow={() => ({ style: { backgroundColor: SUB_TABLE_BACKGROUND } })}
              rowSelection={targetRowSelection}
            />
          ),
          expandedRowKeys: expandedRowCampaignIds,
          onExpandedRowsChange: onExpandedRowsChange,
        }}
      />
    </Flex>
  )
}

export default SponsoredProductsView
